export function registerCustomElement(
  ...args: Parameters<typeof customElements.define>
) {
  const isExist = customElements.get(args[0]);

  if (isExist) return;

  customElements.define(...args);
}
